module.exports = __webpack_public_path__ + "img/2-1.453f6a76.svg";